/* t4s-mega-stack-fix.js
   Purpose: Protect elements inside .t4s-mega-cat-stack from runtime inline positioning
   Strategy:
   - If a fastdom-like API `fastdomT4s` exists, wrap its `mutate` to snapshot/restore positioning
     for elements matching `.t4s-mega-cat-stack [id^="bk_"]`.
   - Run a one-time cleanup to remove positional inline styles on DOM ready.
   - Install a MutationObserver on the document to revert style attribute changes on matching elements.
   The script is defensive and no-ops if APIs are not present.
*/
(function(){
  'use strict';

  function cleanPos(el){
    if(!el || !el.style) return;
    el.style.position = 'static';
    el.style.left = 'auto';
    el.style.top = 'auto';
    ['transform','margin','right'].forEach(function(p){
      try{ el.style.removeProperty(p); }catch(e){}
    });
  }

  function cleanupAll(){
    try{
      document.querySelectorAll('.t4s-mega-cat-stack [id^="bk_"]').forEach(function(el){
        cleanPos(el);
      });
    }catch(e){}
  }

  // Run once after DOM ready
  if(document.readyState === 'complete' || document.readyState === 'interactive'){
    setTimeout(cleanupAll, 30);
  } else {
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(cleanupAll, 30); });
  }

  // Observe style attribute changes and clean them for matching elements
  try{
    var observer = new MutationObserver(function(muts){
      muts.forEach(function(m){
        if(m.type === 'attributes' && m.attributeName === 'style'){
          var t = m.target;
          try{ 
            if(t && t.matches && t.matches('.t4s-mega-cat-stack [id^="bk_"]')) {
              cleanPos(t);
            }
          }catch(e){}
        }
      });
    });
    observer.observe(document.documentElement || document.body, { attributes: true, subtree: true, attributeFilter: ['style'] });
  }catch(e){}

  // fastdomT4s mutate wrapper installer
  function installFastdomWrapper(){
    try{
      if(!window.fastdomT4s || typeof window.fastdomT4s.mutate !== 'function') return false;

      var _origMutate = window.fastdomT4s.mutate.bind(window.fastdomT4s);

      window.fastdomT4s.mutate = function(cb, ctx){
        try{
          var els = Array.prototype.slice.call(document.querySelectorAll('.t4s-mega-cat-stack [id^="bk_"]'));
          var snap = els.map(function(el, index){
            return {
              el: el,
              index: index
            };
          });

          var wrapped = function(){
            try{
              if(typeof cb === 'function') return cb.apply(ctx || this, arguments);
            }finally{
              try{
                snap.forEach(function(s){
                  try{
                    s.el.style.position = 'static';
                    s.el.style.left = 'auto';
                    s.el.style.top = 'auto';
                    s.el.style.removeProperty('transform');
                    s.el.style.removeProperty('margin');
                    s.el.style.removeProperty('right');
                  }catch(e){}
                });
              }catch(e){}
            }
          };

          return _origMutate(wrapped);
        }catch(e){
          return _origMutate(cb);
        }
      };

      return true;
    }catch(e){
      return false;
    }
  }

  // Try to install immediately; if not present, poll until available (short timeout)
  if(!installFastdomWrapper()){
    var tries = 0, maxTries = 60;
    var poll = setInterval(function(){
      if(installFastdomWrapper() || ++tries >= maxTries) clearInterval(poll);
    }, 50);
  }

})();
